import { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { Spinner } from '../../../components/widgets/Spinner';
import VisualizationContext from '../../../contexts/VisualizationContext';
import { api } from '../../../services/api';
import { apiSensedia } from '../../../services/api-sensedia';
import GestaoLeads from './gestao/GestaoLeads';
import { KanbanLeads } from './kanban/KanbanLeads';

function HomeLeads() {
  const { visualizationState, setVisualizationState, fetchUserTypeState } =
    useContext(VisualizationContext);
  const [loading, setLoading] = useState(false);

  return (
    <>
      {loading ? (
        <div className="tw-flex tw-flex-col tw-h-full tw-items-center tw-justify-center tw-gap-1 tw-text-[1.3rem] tw-font-bold">
          <span>Carregando... </span>
          <Spinner />
        </div>
      ) : (
        <>
          {visualizationState === 'gestao' && (
            <Navigate to={'/corretor/leads/gestao'} />
          )}
          {visualizationState === 'card' && (
            <Navigate to={'/corretor/leads/kanban'} />
          )}
        </>
      )}
    </>
  );
}

export default HomeLeads;
